import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

const queryInstance = axios.create({
	baseURL: config.api,
	headers: {
		'Content-Type': 'application/json'
	}
});

queryInstance.interceptors.response.use(
	response => responseSuccessHandler(response),
	error => responseErrorHandler(error)
);

const responseSuccessHandler = response => {
	return response;
};

const responseErrorHandler = error => {
	return Promise.reject(error);
}

class QueryApi {
  static async get(path) {
    queryInstance.defaults.headers.common['Authorization'] = await tokenApi.GetTokenAsync();
    try {
      const response = await queryInstance.get(path);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  static async post(path, payload) {
    queryInstance.defaults.headers.common['Authorization'] = await tokenApi.GetTokenAsync();
    try {
      const response = await queryInstance.post(path, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  static async patch(path, payload) {
    queryInstance.defaults.headers.common['Authorization'] = await tokenApi.GetTokenAsync();
    try {
      const response = await queryInstance.patch(path, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  static async delete(path, payload) {
    queryInstance.defaults.headers.common['Authorization'] = await tokenApi.GetTokenAsync();
    try {
      const response = await queryInstance.delete(path, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}


export default QueryApi;
